<div class="unit-header-container" [class.upper-unit]="!isComunidad">
  <button *ngIf="canManageUnit()" mat-icon-button [matMenuTriggerFor]="menu" class="menu-button" aria-label="Acciones de la unidad">
    <mat-icon>more_vert</mat-icon>
  </button>
  <div class="header-content">

    <!-- Info section -->
    <div class="header-info">
      <app-entity-photos *ngIf="isComunidad" class="community-photos" [id]="unit.id" [unit]="true" [compactOnMobile]="true" />
      <div *ngIf="!isComunidad" class="unit-level-icon" aria-hidden="true">
        <mat-icon *ngIf="unitIcon !== 'church-group'">{{ unitIcon }}</mat-icon>
        <mat-icon *ngIf="unitIcon === 'church-group'" svgIcon="church-group"></mat-icon>
      </div>

      <!-- Fila nombre y menú -->
      <div class="name-row">
        <div class="name-title">
          <span *ngIf="!isComunidad" class="unit-level-label">{{ unit.levelName }}</span>
          <h1 class="unit-name">
            {{ unit.name }}
            <span class="unit-meta hide-mobile" *ngIf="isComunidad && unit.costCentre">
              <span *ngIf="unit.costCentre" class="cost-centre-badge">{{ unit.costCentre }}</span>
            </span>
            <span *ngIf="parentHierarchy.length" class="mobile-unit-hierarchy">
              <ng-container *ngFor="let parent of parentHierarchy; let first = first">
                <span *ngIf="!first" aria-hidden="true"> - </span>
                <a *ngIf="parent.id; else mobileParentName" [routerLink]="['/units', parent.id]">{{ parent.name }}</a>
                <ng-template #mobileParentName><span>{{ parent.name }}</span></ng-template>
              </ng-container>
            </span>
          </h1>
          <div *ngIf="!isComunidad && (unitCode || unit.costCentre)" class="unit-codes">
            <span *ngIf="unitCode" class="unit-code" matTooltip="Código de la unidad">{{ unitCode }}</span>
            <span *ngIf="unit.costCentre" class="unit-code" [matTooltip]="'Centro de costo: ' + unit.costCentre">{{ unit.costCentre }}</span>
          </div>

        </div>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="onAddMember()" *ngIf="isComunidad">
            <mat-icon>person_add</mat-icon>
            <span>Agregar miembro</span>
          </button>
          <button mat-menu-item (click)="onMenuAction('edit')">
            <mat-icon>edit</mat-icon>
            <span>Editar</span>
          </button>
          <button mat-menu-item (click)="onMenuAction('change-parent')">
            <mat-icon>account_tree</mat-icon>
            <span>Cambiar unidad superior</span>
          </button>
          <button mat-menu-item (click)="onNavigateToParentHistory()">
            <mat-icon>history</mat-icon>
            <span>Historial de cambios de unidad superior</span>
          </button>
          <button mat-menu-item (click)="onNavigateToEvents()" *ngIf="isComunidad">
            <mat-icon>event_note</mat-icon>
            <span>Eventos</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item class="danger-menu-item" (click)="onMenuAction('delete')">
            <mat-icon>delete</mat-icon>
            <span>Eliminar</span>
          </button>
        </mat-menu>
      </div>

      <div class="unit-leader">
        <mat-icon aria-hidden="true">person_outline</mat-icon>
        <div>
          <span class="section-label">Dirigente</span>
          <span class="leader-identity">
            <a *ngIf="unit.leader && unit.leaderId; else leaderName" [routerLink]="['/people', unit.leaderId]">{{ unit.leader }}</a>
            <ng-template #leaderName><span class="leader-name">{{ unit.leader || 'Sin dirigente asignado' }}</span></ng-template>
            <small *ngIf="unit.leader && unit.leaderMinistryName"> ({{ unit.leaderMinistryName }})</small>
          </span>
        </div>
      </div>
      <div class="unit-details">
      <div *ngIf="parentHierarchy.length" class="upper-hierarchy">
        <span class="section-label">Pertenece a</span>
        <div *ngFor="let parent of parentHierarchy" class="parent-unit">
          <mat-icon aria-hidden="true">{{ parent.icon }}</mat-icon>
          <div>
            <small>{{ parent.label }}</small>
            <a *ngIf="parent.id; else parentName" [routerLink]="['/units', parent.id]">{{ parent.name }}</a>
            <ng-template #parentName><span>{{ parent.name }}</span></ng-template>
          </div>
        </div>
      </div>

      <!-- Fecha de inauguración -->
      <div class="info-row" *ngIf="isComunidad && inauguracionDate">
        <span class="info-label">Fecha de inauguración:</span>
        <span>{{ inauguracionDate | date:'dd/MM/yyyy' }}</span>
        <span class="info-secondary">({{ inauguracionAge }})</span>
      </div>
      </div>

    </div>

  </div>
</div>
